module.exports = __webpack_public_path__ + "img/Icon_add_evaluation_hover.c1839cd0.svg";